import React, { useState } from "react";
import "./CreateUser.css";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { addCategory } from "proxyUrl";

const CategoryAdd = () => {
  const [category, setCategory] = useState({
    title: "",
    slug: "",
    description: "",
  });
  const [status, setStatus] = useState("1");
  const [submiteed, setSubmiteed] = useState(false);

  const navigate = useNavigate();

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmiteed(true);

    if (!category.title || !category.slug || !category.description) {
      toast.error("Please fill all fields!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setSubmiteed(false);
      return;
    }

    try {
      const res = await axios.post(
        addCategory,
        {
          title: category.title,
          slug: category.slug,
          description: category.description,
          status: status,
        },
        {
          withCredentials: true,
        }
      );

      if (res.status === 200) {
        toast.success("Category created successfully!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          navigate("/admin/category");
        }, 2200);
      } else {
        setSubmiteed(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setSubmiteed(false);
    }
  };

  return (
    <>
      <div className="mt-7 rounded-2xl py-4 dark:bg-navy-800">
        <form
          className="create-user-form bg-white dark:bg-navy-800"
          onSubmit={handleSubmit}
        >
          <div className="create-form-wrapper">
            <div className="field">
              <div className="input">
                <label
                  htmlFor="title"
                  className="text-navy-900 dark:text-white"
                >
                  Title
                </label>
                <input
                  type="text"
                  placeholder="Category title"
                  id="title"
                  name="title"
                  value={category.title}
                  onChange={handleInput}
                />
              </div>
              <div className="input">
                <label
                  htmlFor="slug"
                  className="text-navy-900 dark:text-white"
                >
                  Slug
                </label>
                <input
                  type="text"
                  placeholder="category-slug"
                  id="slug"
                  name="slug"
                  value={category.slug}
                  onChange={handleInput}
                />
              </div>
            </div>

            <div className="field">
              <div className="input">
                <label
                  htmlFor="description"
                  className="text-navy-900 dark:text-white"
                >
                  Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  placeholder="Category description"
                  className="h-[100px] resize-none"
                  value={category.description}
                  onChange={handleInput}
                />
              </div>
              <div className="input relative">
                <label
                  htmlFor="status-select"
                  className="text-navy-900 dark:text-white"
                >
                  Status
                </label>
                <select
                  id="status-select"
                  value={status}
                  onChange={handleStatusChange}
                  className="mt-2"
                >
                  <option value="1">Active</option>
                  <option value="0">Disabled</option>
                </select>
              </div>
            </div>

            <div className="bg-transperent mx-2 mt-5 flex items-center justify-center">
              {submiteed ? (
                <div className="field cursor-pointer">
                  <div className="my-5 rounded-md bg-gray-300 py-3 px-12 text-white">
                    <button disabled>Loading....</button>
                  </div>
                </div>
              ) : (
                <div className="field cursor-pointer">
                  <div className="my-5 rounded-md bg-primaryBlue py-3 px-12 text-white">
                    <button type="submit">Submit</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
      <ToastContainer />
    </>
  );
};

export default CategoryAdd;
